import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Row, Col } from "react-bootstrap";
import withReactContent from "sweetalert2-react-content";
import { loading } from "../../../redux/actions/loadingAction";
import { logout } from "../../../redux/actions/logoutAction";
import Swal from "sweetalert2";
import DataTable from "../../../components/DataTable";

import BoxCard from "../../../components/BoxCard";
import Breadcrumb from "../../../components/Breadcrumb";
import ModalFarmCertificate from "../../../components/Data_Management/Modal.Farm_Cert";
import InputText from "../../../components/InputText";
import InputSelect from "../../../components/InputSelect";

import * as API from "../../../utils/apis";

const MySwal = withReactContent(Swal);

function FarmCertificate() {
  const dispatch = useDispatch();
  const history = useHistory();
  const { t, i18n } = useTranslation(["common", "footer"]);
  const statusCheck = useSelector((state) => state.statusCheck);
  const initialForm = {
    id: "",
    name: "",
    statusId: "",

    createBy: "",
    createByName: "",
    updateBy: "",
    updateByName: "",

    idEdit: "",
    mode: "",

    search: "",
    limit: 10,
    page: 1,
    totalPages: 1,
    sortDir: "DESC",
    sortBy: "id",
    totalElements: 0,
    numberOfElements: 0,

    headTitle: [
      {
        name: "ลำดับ",
        width: "50px",
        sortFlg: false,
      },
      {
        sortBy: "name",
        name: "ประเภทมาตรฐานฟาร์ม",
        sortFlg: true,
      },

      {
        sortBy: "statusId",
        name: "สถานะ",
        sortFlg: true,
      },
      {
        name: "จัดการ",
        sortFlg: false,
      },
    ],
  };
  const [form, setForm] = useState(initialForm);

  const [listDiseaseType, setListDiseaseType] = useState([]);

  const [showFarmCert, setShowFarmCert] = useState(false);

  const initStatusSelectValue = [];
  const [statusSelectValue, setStatusSelectValue] = useState(
    initStatusSelectValue
  );
  const selectStatusList = [
    { value: 1, label: "ใช้งาน" },
    { value: 2, label: "ไม่ใช้งาน" },
  ];
  const [statusList, setStatusList] = useState(selectStatusList);
  const [isClearSearch, setIsClearSearch] = useState(false);

  const breadcrumbPath = [
    { path: "/home", name: "หน้าหลัก" },
    {
      path: "/data-manage/web-settings/news",
      name: "บริหารจัดการข้อมูลส่วนกลาง",
    },
    { path: "/data-manage/master-data/animal-type", name: "Master Data" },
    { path: "active", name: "ประเภทมาตรฐานฟาร์ม" },
  ];

  useEffect(() => {
    getFarmCertificate();
  }, [form.limit, form.page, form.sortBy, form.sortDir, isClearSearch]);

  const getFarmCertificate = async () => {
    dispatch(loading(true));
    try {
      const response = await API.getFarmCertificate(
        "",
        form.statusId,
        form.search,
        form.sortBy,
        form.sortDir,
        form.page,
        form.limit
      );
      const data = await response?.data;
      let arrayFarmCert = [];
      if (response.status === 200) {
        dispatch(loading(false));
        data.content.map((element) => {
          arrayFarmCert.push({
            id: element.id,
            name: element.name,
            statusId: element.statusId,
          });
        });
        setForm({
          ...form,
          totalPages: data.totalPages,
          totalElements: data.totalElements,
          numberOfElements: data.numberOfElements,
        });
        setListDiseaseType(arrayFarmCert);
      }
    } catch (error) {
      dispatch(loading(false));
      if (error.response && error.response.status === 401) {
        dispatch(logout({ history }));
      }
      console.log(error);
    }
  };

  const getStatusColor = (idStatus) => {
    let statusColor;
    if (statusCheck && statusCheck.length > 0) {
      statusCheck.map((item, index) => {
        if (item.id === idStatus) {
          statusColor = (
            <div className="d-flex justify-content-center">
              <div
                style={{ background: item.color }}
                className="box-status font14 px-4 text-center text-white"
              >
                <span>{item.status}</span>
              </div>
            </div>
          );
        }
      });
    }
    return statusColor;
  };

  const getFilter = async (type, isChange1, isChange2) => {
    if (type === "page") {
      setForm({
        headTitle: form.headTitle,
        sortBy: form.sortBy,
        sortDir: form.sortDir,
        page: isChange1,
        limit: form.limit,
        search: form.search,
      });
    } else if (type === "limit") {
      setForm({
        headTitle: form.headTitle,
        sortBy: form.sortBy,
        sortDir: form.sortDir,
        page: form.page,
        limit: isChange1,
        search: form.search,
      });
    } else if (type === "filter") {
      setForm({
        headTitle: form.headTitle,
        sortBy: isChange1,
        sortDir: isChange2,
        page: form.page,
        limit: form.limit,
      });
    }
  };

  const clearSearch = () => {
    setForm(initialForm);
    setIsClearSearch(!isClearSearch);
  };

  const buttonAddFarmCert = () => {
    return (
      <div className="d-flex justify-content-end ">
        <button
          className="btn btn-add text-white"
          onClick={() => toAddFarmCert()}
        >
          <i className="fas fa-plus mr-1 "></i>เพิ่ม
        </button>
      </div>
    );
  };

  const toSearch = () => {
    setForm({ ...form, page: 1 });
    setIsClearSearch(!isClearSearch);
  };

  const buttonSearch = () => {
    return (
      <>
        <button className="btn btn-danger mr-2" onClick={() => clearSearch()}>
          {t("clear")}
        </button>

        <button className="btn btn-success" onClick={() => toSearch()}>
          ค้นหา
        </button>
      </>
    );
  };

  const toAddFarmCert = () => {
    setForm({ ...form, mode: "add", idEdit: "" });
    setShowFarmCert(true);
  };

  const editModalFarmCert = (id) => {
    setForm({ ...form, mode: "edit", idEdit: id });
    setShowFarmCert(true);
  };

  const delFarmCert = async (id) => {
    MySwal.fire({
      text: `ยืนยันที่จะลบ `,
      icon: "question",
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: "ยกเลิก",
      confirmButtonText: "ตกลง",
    }).then(async (result) => {
      if (result.value) {
        try {
          const response = await API.deleteFarmCertificate(id);
          if (response.status === 200) {
            MySwal.fire({
              text: `ลบสำเร็จ`,
              icon: "success",
              confirmButtonText: "ตกลง",
            }).then(async (result) => {
              await getFarmCertificate();
            });
          }
        } catch (error) {
          if (error.response && error.response.status === 401) {
            dispatch(logout({ history }));
          } else {
            MySwal.fire({
              text: `ลบไม่สำเร็จ กรุณาลองใหม่อีกครั้ง`,
              icon: "warning",
              confirmButtonText: "ตกลง",
            });
          }
          console.log("error", error);
        }
      }
    });
  };

  const addSaveFarmCert = (data) => {
    const dataFarmCert = {
      name: data.farmCert.name,
      statusId: data.farmCert.statusId,
    };

    MySwal.fire({
      text: `ต้องการบันทึก `,
      icon: "question",
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: "ยกเลิก",
      confirmButtonText: "ตกลง",
    }).then(async (result) => {
      if (result.value) {
        try {
          const response =
            data.mode === "add"
              ? await API.saveFarmCertificate(dataFarmCert)
              : await API.updateFarmCertificate(
                  data.farmCert.farmCertId,
                  dataFarmCert
                );
          if (response.status === 200) {
            setShowFarmCert(false);
            await getFarmCertificate();
          }
        } catch (error) {
          dispatch(loading(false));
          if (error.response && error.response.status === 401) {
            dispatch(logout({ history }));
          } else {
            MySwal.fire({
              text: `บันทึกไม่สำเร็จ กรุณาลองใหม่อีกครั้ง`,
              icon: "warning",
              confirmButtonText: "ตกลง",
            });
          }
          console.log("error", error);
        }
      }
    });
  };

  const renderTableFarmCert = (data) => {
    if (data.length > 0) {
      return data.map((item, i) => (
        <tr key={i + item.name + item.statusId} className="text-center">
          <td>{form.limit * (form.page - 1) + (i + 1)}</td>
          <td>{item.name}</td>
          <td>{getStatusColor(item.statusId) || "-"}</td>

          <td>
            <div className="d-flex justify-content-center ">
              <button
                className="btn btn-add mr-2 "
                onClick={() => editModalFarmCert(item.id)}
              >
                <img className="icon-btn" src="/svg/btn-edit.svg" alt="edit" />
              </button>
              <button
                className="btn btn-del mr-2 "
                onClick={() => delFarmCert(item.id)}
              >
                <img className="icon-btn " src="/svg/btn-del.svg" alt="del" />
              </button>
            </div>
          </td>
        </tr>
      ));
    } else {
      return (
        <tr>
          <td scope="col" colSpan={12} className="text-center font14">
            {t("no_data")}
          </td>
        </tr>
      );
    }
  };

  return (
    <div className=" ">
      <div className="pl-4 bg-white ml30 d-flex">
        <div className="mr-auto p-2 ">
          <Breadcrumb data={breadcrumbPath} />
        </div>
      </div>

      <div className="bg-gray-light ">
        <div className="px-4 pt-3 container-fixed-footer ">
          <BoxCard classNameBox="" title="ตัวกรอง" headRight={buttonSearch()}>
            <Row>
              <Col lg={2} md={6} sm={12} xs={12}>
                <InputText
                  type="text"
                  title="ชื่อมาตรฐาน"
                  idName="farmCertName"
                  value={form.search}
                  star={false}
                  placeholder="โปรดระบุ"
                  classLabel="normal"
                  handleChange={(value) => {
                    setForm({ ...form, search: value });
                  }}
                />
              </Col>
              <Col lg={2} md={6} sm={12} xs={12}>
                <InputSelect
                  title="สถานะ"
                  star={false}
                  placeholder="กรุณาเลือก"
                  idName="title"
                  classLabel="normal"
                  selectValue={statusSelectValue}
                  optionsList={statusList}
                  handleSelectValue={(value) =>
                    setStatusSelectValue([
                      { value: value.value, label: value.label },
                    ])
                  }
                  handleChange={(value) =>
                    setForm({ ...form, statusId: value.value })
                  }
                />
              </Col>
            </Row>
          </BoxCard>

          <BoxCard
            title="รายการมาตรฐานฟาร์ม"
            classNameBox="mt-4"
            headRight={buttonAddFarmCert()}
          >
            <DataTable
              headColumns={form.headTitle}
              totalPages={form.totalPages}
              page={form.page}
              limit={form.limit}
              sortDir={form.sortDir}
              sortBy={form.sortBy}
              getLimit={(limit) => getFilter("limit", limit)}
              getFilter={(sortBy, sortDir) =>
                getFilter("filter", sortBy, sortDir)
              }
              getPage={(page) => getFilter("page", page)}
              totalItems={form.totalElements}
              numberOfItems={form.numberOfElements}
              isClear={isClearSearch}
            >
              {renderTableFarmCert(listDiseaseType)}
            </DataTable>
          </BoxCard>
          {showFarmCert && (
            <ModalFarmCertificate
              show={showFarmCert}
              close={() => setShowFarmCert(false)}
              save={(value) => addSaveFarmCert(value)}
              mode={form.mode}
              idEdit={form.idEdit}
            />
          )}
        </div>
      </div>
    </div>
  );
}
export default FarmCertificate;
